<template>
  <div class="mt-2 flex overflow-hidden flex-grow">
    <div class="overflow-hidden flex flex-col pb-4 flex-grow bg-trader-gray mr-2">

      <!--go back  -->
      <div class="w-full h-10">
        <CGoBack/>
      </div>

      <!--Bearbeitung Weißer hintergrund  -->
      <div class="flex-grow overflow-hidden px-10 h-full flex text-center justify-center">
        <div class="overflow-auto bg-white rounded p-10 max-w-[1000px] flex-grow">
          <div class="flex items-center justify-between h-10 mb-4 w-full rounded">
            <div class="w-full bg-primary p-2 rounded">
              <span class="text-xl ">Produktfeld Übersicht</span>
            </div>
          </div>
          <div class="flex flex-col sm:flex-row w-full">
            <div class="w-full">
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Name:</span>
                <input class="border p-2 rounded w-3/4" v-model="fieldName" data-ui="input-productfield-name">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Feld beim Werbemittel-Duplizieren nicht mit kopieren:</span>
                <input type="checkbox" class="border rounded ml-2" v-model="dontCopy" data-ui="dontCopy">
              </div>
              <div class="flex mt-2 text-center w-full">
                <span class="bg-primary w-1/4 p-2 rounded">Nicht für künftige Werbemittel in den Stammdaten speichern:</span>
                <input type="checkbox" class="border rounded ml-2" v-model="ignoreOnPlaceProduct" data-ui="ignoreOnPlaceProduct">
              </div>
              <spinner  v-if="isLoading" class="col-span-4 w-full mt-6"/>
              <button @click="editProductCustomField" class="mr-1 w-full rounded mt-2 p-3 bg-trader-green hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" data-ui="button-save-productfield">
                Speichern
              </button>
              <button @click="deleteTrue" class="mr-1 w-full rounded mt-2 p-3 bg-trader-red hover:bg-trader-blue hover:text-white transition duration-200 ease-in-out" data-ui="button-delete-productfield">
                Löschen
              </button>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Sidebar/>
  </div>
</template>


<script >

import Sidebar from "@/components/Administration/Sidebar.vue";
import {gql} from "@apollo/client/core";
import apolloClient from "@/apolloClient";
import router from "@/router";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import SignalBus from "@/application/SignalBus";
import Spinner from "@/components/Base/Spinner.vue";
import CGoBack from "@/components/Administration/CGoBack.vue";

export default {
  components: {CGoBack, Spinner, Sidebar},
  data(){
    return{
      fieldName: '',
      dontCopy: false,
      description: '',
      isActive: '',
      isLoading: false,
      productFieldId: 0,
      productField: null,
      accordionIndex: 0,
      ignoreOnPlaceProduct: false
    }
  },
  mounted() {

  },
  methods:{
    deleteTrue( ) {
      eventBus.openConfirm({
        title: "Produktfeld Dialog",
        message: "Möchten Sie dieses Produktfeld wirklich löschen?",
        onAccept: () => {
          this.deleteProductCustomField();
        }
      });
    },

    goBack(){
      router.push("/administration")
    },
   async deleteProductCustomField() {

     this.isLoading = true;

       const mutation = gql`
        mutation deleteProductCustomField($productFieldId: Int!) {
          deleteProductCustomField(productFieldId: $productFieldId) {
            success
            code
          }
        }
      `;
       try {
         const variables = {
           productFieldId: this.productFieldId
         };
         const {data} = await apolloClient.mutate({mutation, variables});

         if (data.deleteProductCustomField.code == "PRODUCT_FIELD_EXISTS_IN_FORMULAR") {
           eventBus.openModal(SuccessConfirmation);
           eventBus.setData({
             title: "Produktfeld Dialog",
             message: "Das Produktfeld konnte nicht gelöscht werden da es bereits in einem Formular existiert.",
           });
         }
         if (data.deleteProductCustomField.success) {
           eventBus.openModal(SuccessConfirmation);
           eventBus.setData({
             title: "Produktfeld Dialog",
             message: "Das Produktfeld wurde gelöscht.",
           });
           router.push(`/administration/${this.accordionIndex}`);
         }
       } catch (error) {
         console.error(error);
       }finally {
          this.isLoading = false;
       }
    },
    async editProductCustomField() {
      const productCustomFieldData = {
        productFieldId:  this.productFieldId,
        fieldName: this.fieldName,
        dontCopy: this.dontCopy,
        ignoreOnPlaceProduct: this.ignoreOnPlaceProduct
      };
      const mutation = gql`
        mutation editProductCustomField($productField: CustomFieldInput!) {
          editProductCustomField(productField: $productField) {
            success
          }
        }
      `;

      try {
        const variables = {
          productField: productCustomFieldData,
        };

        const {data} = await apolloClient.mutate({mutation, variables});
        if (data.editProductCustomField.success) {
          SignalBus.emit("productFieldUpdated");
          eventBus.openModal(SuccessConfirmation);
          eventBus.setData({
            title: "Produktfeld Dialog",
            message: "Das Produktfeld wurde gespeichert.",
          });
        }


      } catch (error) {
        console.error("Daten konnten nicht aktualisiert werden", error);
      }
    },

    async getProductCustomField() {
      const query = gql`
        query getProductCustomField($productFieldId: Int!) {
          getProductCustomField(productFieldId: $productFieldId)  {
           idProductCustomField
           fieldName
           dontCopy
            ignoreOnPlaceProduct
          }
        }
      `;
      try {
        const variables = {
          productFieldId: this.productFieldId
        };

        const {data} = await apolloClient.query({query, variables});
        this.productField = data.getProductCustomField;
        this.fieldName = this.productField.fieldName
        this.dontCopy = this.productField.dontCopy
        this.ignoreOnPlaceProduct = this.productField.ignoreOnPlaceProduct
        
      } catch (error) {
        console.error("Fehler beim abrufen von getProductCustomField",error);
      }
    },
  },
  watch:{
    '$route.params.productFieldId': function (newId, oldId) {
      this.productFieldId = newId;
      this.getProductCustomField();
    },
  },
  created() {
    if(this.$route.params.productFieldId != null && typeof this.$route.params.productFieldId != 'undefined' && this.$route.params.productFieldId != '' ){
      this.productFieldId = this.$route.params.productFieldId;
      this.getProductCustomField();
    }
    this.accordionIndex = this.$route.params.accordionIndex;
  }
}
</script>
